/* eslint-disable react-hooks/exhaustive-deps */
import { Table } from 'antd';
import { expandIcon } from "datastake-daf/dist/components";
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { getColumns, renderRows } from './helper';
import { getLocales } from '../../../../components/Table/newTable';

const expandableNamespaces = [
  'checks',
  'challenges',
  'documentationChecks',
  'managementSystems',
];

const checkIfIsExpandable = {
  checks: (data) => data.find((d) => Array.isArray(d.sources)),
  challenges: (data) => data.find((d) => Array.isArray(d.checks)),
  documentationChecks: (data) => data.find((d) => Array.isArray(d.sources)),
  managementSystems: (data) => data.find((d) => Array.isArray(d.sources)),
};

const checkIfRowIsExpandable = {
  challenges: (d) => Array.isArray(d.checks) && d.checks.length > 1
};

export default function TableT({
  data = null,
  k = null,
  t = (s) => s,
  actions: tableActions,
}) {
  const [expanded, setExpanded] = useState([]);
  const [toggledKeys, setToggledKeys] = useState([]);
  const loadingKeys = useRef({});
  const isExpandable = useMemo(() =>
    checkIfIsExpandable[k] ? checkIfIsExpandable[k](data || []) : false, [k, data]);

  const toggle = useCallback((key) => setExpanded((prev) => [...prev, key]), []);
  const unToggle = useCallback((key) => setExpanded((prev) => [...prev.filter((p) => p !== key)]), []);

  const columns = useMemo(() =>
    getColumns({
      isExpandable,
      namespace: k,
      t,
      expandActions: {
        toggle: (key) => setToggledKeys((prev) => [...prev, key]),
        unToggle: (key) => setToggledKeys((prev) => [...prev.filter((p) => p !== key)]),
        expanded
      },
      actions: tableActions,
    }),
    [k, t, expanded, toggle, unToggle, isExpandable]);

  const dataSource = data ? data.map((d, i) => ({ ...d, key: `${k}-${i + 1}`, index: i + 1 })) : [];

  const toggleExpand = useCallback((expanded, { key }) =>
    expanded ? toggle(key) : unToggle(key), [toggle, unToggle]);

  const expandable = useMemo(() =>
    (isExpandable && expandableNamespaces.includes(k)) ? ({
      onExpand: toggleExpand,
      rowExpandable: (a) => {
        if (checkIfRowIsExpandable[k]) {
          return checkIfRowIsExpandable[k](a);
        }
        return true;
      },
      expandedRowRender: (d) => renderRows({
        data: d,
        columns,
        expanded: toggledKeys,
      }),
      expandedRowKeys: expanded,
      expandedRowClassName: () => 'expanded-table-cell'
    }) : false, [t, isExpandable, toggleExpand, expanded, k, data, columns, toggledKeys]);

  return (
    <>
      <div className='daf-table-wrapper no-pagination'>
        <Table
          sticky
          locale={getLocales(t)}
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          className={`table ${k} ${isExpandable ? 'expandable' : 'not-expandable'}`}
          expandable={expandable}
          rowClassName={(d) => expanded.includes(d.key) ? 'active-row' : ''}
          size="small"
          {...expandable ? {
            expandIcon: (props) => expandIcon({
              ...props,
              arrows: true,
              toggledKeys,
              setToggledKeys,
              loadingKeys,
            })
          } : {}}
        />
      </div>
    </>
  );
}
